import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  username
  t2
  userInfo
  role
  getToken(): string {

    return localStorage.getItem('token');
  }

  getRole():string{
    return localStorage.getItem('role');
  }
  constructor(private httpClient:HttpClient,private route:Router) { }


  
  login(username: string, password: string) {
 
    return this.httpClient.post('http://www.testback.kompar-energie.com/auth/login', {
    
        "username":username,
        "password":password
     },
     {
      headers:{
        'Content-Type':"application/json"
      }
        })
    .subscribe(
      data => {
        this.t2=data;

        if(this.t2.message == "email or password is wrong."){
         alert("erreur d'authentification");
          return false;
        }else{
          this.username = username ;
          localStorage.setItem('username',username);
  
         
       
  
         localStorage.setItem('token', data['token']); 
         setTimeout(()=>{                           //<<<---using ()=> syntax
          this.signOut();
    
    }, 1800000);
         this.getInfo(username).subscribe(data=>{
           this.userInfo = data;
           this.role = this.userInfo.role;
           localStorage.setItem('role',this.role);
  
         });    
  
          this.route.navigate(['/accueil']);
        }
      
      
  

      },error=>{
        alert("erreur");
      }
    );
  }
  getInfo(username){
    return this.httpClient.get('http://www.testback.kompar-energie.com/User/getByUsername/'+username);
  }
  signOut() {
    localStorage.clear();
    location.reload();
  }
 
}
